export const REGISTER_FIELD_CHANGE = 'RESTRICTIONS/REGISTER_FIELD_CHANGE';
export const SELECT_CHANGE = 'RESTRICTIONS/SELECT_CHANGE';
export const SET_RESTRICTIONS = 'RESTRICTIONS/SET_RESTRICTIONS';
export const HANDLE_LOADING = 'RESTRICTIONS/HANDLE_LOADING';
export const CLEAR_RESTRICTIONS = 'RESTRICTIONS/CLEAR_RESTRICTIONS';
export const SET_RESTRICTIONS_ERRORS = 'RESTRICTIONS/SET_RESTRICTIONS_ERRORS';
export const CLEAR_RESTRICTIONS_ERRORS = 'RESTRICTIONS/CLEAR_RESTRICTIONS_ERRORS';
